/**
 * DoodleBackground — Ambient SVG doodle overlay.
 *
 * Renders inside `<main>` as an absolute layer pinned to the
 * viewport portion. Cards with solid bg-white/bg-stone backgrounds
 * naturally cover it — doodles only peek through in margins/gaps.
 *
 * @since 1.1.0
 */
import { useDoodlePattern } from './useDoodlePattern';

export function DoodleBackground() {
    const pattern = useDoodlePattern();

    if (!pattern) return null;

    return (
        <div
            className="pointer-events-none absolute inset-0 opacity-[0.0275] dark:invert dark:opacity-[0.0325]"
            aria-hidden="true"
            style={{
                backgroundImage: `url("${pattern.svg}")`,
                backgroundRepeat: 'repeat',
                backgroundSize: '200px 200px',
            }}
        />
    );
}
